import styled from 'styled-components';
import ChoiceBoxSection from '@gcc/pip-components/dist/ChoiceBoxSection';
import { ChoiceBorder } from '@gcc/pip-components/dist/ChoiceBox/styles';
import Carousel from '@gcc/pip-components/dist/Carousel';

import {
  LeftArrowBox,
  RightArrowBox,
  GradientLeft,
  GradientRight,
} from '@gcc/pip-components/dist/Carousel/styles';

const fontColor = 'color: #212120;';

export const Divider = styled.div`
  margin: 0.5rem -1rem 1.5rem -1rem;
  padding-bottom: 0px;
`;

export const ProductOrder = styled.div`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 125%;
  ${fontColor}
`;

export const ProductInfoContainer = styled.div`
  padding-left: 5px;
  font-size: 12pt;
`;

export const PriceContainer = styled.div`
  padding-top: 15px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  ${fontColor}
`;

export const Description = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  padding-bottom: 16px;
`;

export const ChoiceBoxSectionContainer = styled.div`
  ${ChoiceBoxSection} {
    margin-bottom: 1rem;
    @media (min-width: 1024px) {
      flex-wrap:wrap;
      justify-content: flex-start;
    }
    position: relative;
  }

  ${ChoiceBoxSection} > span:first-child{
    border: 1px solid black;
    padding: 2px 2px;
    opacity: 0;
    z-index: 100;
    background:#fff;
    position: absolute;
    top:0;
    left:0;
  }

  ${ChoiceBoxSection}:hover > span:first-child{
    opacity: 1;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  @media (min-width: 1024px) {
    flex-flow: row wrap;
  }
  justify-content: flex-start;
  padding-bottom:2%;
  margin-bottom: -10px;
  box-sizing: border-box;
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    width: 100%
  }
`;

export const ChoiceWrapper = styled.div`
  flex: 0 1 auto;
  margin-bottom: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  width: calc(33.33% - 20px);
  @media (min-width: 320px) and (max-width: 340px) {
    width: 230px;
  }
  @media (min-width: 341px) and (max-width: 360px) {
    width: 250px;
  }
  @media (min-width: 361px) and (max-width: 380px) {
    width: 260px;
  }
  @media (min-width: 381px) and (max-width: 399px) {
    width: 280px;
  }
  @media (min-width: 400px) and (max-width: 1023px) {
    width: 320px;
  }
  @media (min-width: 1024px) and (max-width: 1304px) {
    width: calc(50% - 20px);
  }

  ${ChoiceBorder} {
    min-width: 200px;
    position: relative;

    @media (max-width: 767px) {
      min-width: 210px;
    }
    max-width: fit-content;
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      max-width: 200px;
    }
    background: #fff;
    border-radius: 3px;
    padding: 14px;
    box-sizing: border-box;
    cursor: pointer;
    margin-right: 16px;
    @media (max-width: 767px) {
      margin-right: 10px;
    }
    height: 100%;
  }

  ul, ol {
    margin-bottom: 0;
  }
`;

export const IeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  position: relative;
  span.highlightLabel {
    color: var(--ui-text-primary, #212120);
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 125%;
    top: 16px;
    left: 16px;
    padding: 4px 8px 2px 8px;
    position: absolute;
    background: var(--status-info-subtle, #B5FFF8);
    border-radius: 16px;
    text-align: center;
    z-index: 1;
    }
`;

export const InfoCardFlexContent = styled.div`
  margin-top: 10px;
  margin-bottom: 5px;

  @media (min-width: 1024px) {
    font-size: 16px;
  }
  @media (max-width: 1023px) {
    font-size: 14px;
  }

  .list__item {
    padding: 0 0 0 0.4em;
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const StyledCarousel = styled(Carousel)`
  ${LeftArrowBox},
  ${RightArrowBox},
  ${GradientLeft},
  ${GradientRight} {
    display: none;
  }
`;
